import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Image, Container } from "react-bootstrap";
import {
  Form,
  Modal,
  Button,
  Icon,
  Message,
  TextArea,
} from "semantic-ui-react";
import defImage from "../../../assets/images/image.png";
import axios from "axios";

function SchoolForm({
  showModal,
  setShowModal,
  setCreated,
  updateSchool,
  setUpdate,
  setIsUpdated,
}) {
  const { shouldUpdate, school } = updateSchool;

  const [newSchool, setSchool] = useState({
    schoolName: "",
    address: "",
    desc: "",
    levels: 0,
    image: "",
    imageUrl: "",
  });

  const [errors, setErrors] = useState({
    schoolName: false,
    address: false,
    desc: false,
    image: false,
    levels: false,
    response: { show: false, type: "success", message: "" },
  });
  const [loadImage, setLoadImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const uploader = useRef(null);

  useEffect(() => {
    return () => {
      setUpdate({ shouldUpdate: false });
    };
    // eslint-disable-next-line
  }, []);

  const showPicker = () => {
    uploader.current.click();
  };

  const handlePickImage = async (event) => {
    const file = event.target.files[0];
    setLoadImage(true);
    const formData = new FormData();
    formData.append("file", file);

    formData.append("upload_preset", "roll_app");

    const options = {
      method: "POST",
      body: formData,
    };

    setSchool({
      ...newSchool,
      image: URL.createObjectURL(file),
    });

    const results = await fetch(
      `${process.env.REACT_APP_CLOUDINARY_API}/image/upload`,
      options
    );
    const response = await results.json();

    setSchool({
      ...newSchool,
      image: URL.createObjectURL(file),
      imageUrl: response ? response.secure_url : file,
    });
    setLoadImage(false);
  };

  const handleAddSchool = async () => {
    try {
      const { schoolName, address, desc, imageUrl, levels } = newSchool;
      if (!schoolName) return setErrors({ ...errors, schoolName: true });
      if (!address) return setErrors({ ...errors, address: true });
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/schools/create`,
        {
          schoolName,
          address,
          desc,
          levels,
          image: imageUrl,
        },
        { headers: { token: localStorage.getItem("token") } }
      );
      setLoading(false);
      if (response.status === 201) {
        localStorage.setItem("token", response.data.data.token);
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "success",
            message: "School successfully created!",
          },
        });
        setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
        setSchool({ ...newSchool, image: "" });
        setShowModal(false);
        setCreated(true);
        return;
      }
      return;
    } catch (error) {
      console.log("error.message", error);
      setLoading(false);
      if (error?.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 400) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 401) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error.response.status === 409) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  const handleUpdateSchool = async () => {
    try {
      const { schoolName, address, image } = newSchool;
      setLoading(true);
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/schools/${school.uuid}/`,
        {
          schoolName: schoolName || school.schoolName,
          address: address || school.address,
          image: image || school.image,
        },
        { headers: { token: localStorage.getItem("token") } }
      );
      setLoading(false);
      if (response.status === 200) {
        setIsUpdated(true);
        setSchool({});
        setUpdate({ shouldUpdate: false, school: {} });
        setShowModal(false);
        return;
      }
    } catch (error) {
      setLoading(false);
      if (error?.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 403) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 404) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error.response.status === 500) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: "Something went wrong on our side, try again later",
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.message,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  return (
    <Modal
      open={showModal}
      centered
      dimmer="blurring"
      size="tiny"
      style={{
        position: "relative",
        height: "80vh",
      }}
      closeOnEscape
    >
      <Container
        fluid
        className="d-flex justify-content-center align-items-center"
      >
        <Row>
          <Col>
            <Modal.Content>
              <Modal.Header
                className="d-flex justify-content-center"
                content={!shouldUpdate ? "Add New School" : "Update School"}
                as="h2"
              />
              <Container>
                <Row>
                  <Col>
                    <Image
                      src={
                        !shouldUpdate && !newSchool.image
                          ? `${defImage}`
                          : newSchool.image
                          ? newSchool.image
                          : school.image
                      }
                      width={100}
                      roundedCircle
                      className="m-3"
                    />

                    <input
                      hidden
                      type="file"
                      ref={uploader}
                      onChange={handlePickImage}
                    />
                    <Button
                      size="tiny"
                      loading={loadImage}
                      primary={newSchool.image ? true : false}
                      onClick={showPicker}
                    >
                      <Icon name="camera" />
                      {!newSchool.image && !shouldUpdate
                        ? "Upload Image"
                        : !shouldUpdate
                        ? "Uploaded"
                        : "Change picture"}
                    </Button>
                  </Col>
                </Row>
              </Container>
              <Message
                content={errors.response.message}
                hidden={!errors.response.show}
                positive={errors.response.type === "success"}
                negative={errors.response.type === "error"}
              />
              <Form size="large" style={{ marginBottom: 30, marginTop: 30 }}>
                <Form.Input
                  fluid
                  icon="building"
                  iconPosition="left"
                  placeholder={
                    !shouldUpdate ? "School name" : school.schoolName
                  }
                  error={errors.schoolName}
                  onChange={(e) => {
                    setSchool({ ...newSchool, schoolName: e.target.value });
                    setErrors({ ...errors, schoolName: false });
                  }}
                />
                <Form.Input
                  fluid
                  icon="map marker alternate"
                  iconPosition="left"
                  placeholder={!shouldUpdate ? "Address" : school.address}
                  error={errors.address}
                  onChange={(e) => {
                    setSchool({ ...newSchool, address: e.target.value });
                    setErrors({ ...errors, address: false });
                  }}
                />
                <Form.Input
                  required
                  fluid
                  icon="angle double up"
                  iconPosition="left"
                  placeholder={
                    !shouldUpdate ? "Number of levels" : school.address
                  }
                  error={errors.levels}
                  onChange={(e) => {
                    setSchool({ ...newSchool, levels: e.target.value });
                    setErrors({ ...errors, levels: false });
                  }}
                />
                <TextArea
                  placeholder="Tell us more"
                  onChange={(e) => {
                    setSchool({ ...newSchool, desc: e.target.value });
                    setErrors({ ...errors, desc: false });
                  }}
                />
              </Form>
              <Modal.Actions>
                <Button
                  negative={shouldUpdate ? false : true}
                  color={shouldUpdate ? "black" : "red"}
                  content="Cancel"
                  icon="close"
                  labelPosition="right"
                  onClick={() => {
                    setUpdate({ shouldUpdate: false, school: {} });
                    setSchool({ ...newSchool, image: "" });
                    setShowModal(false);
                  }}
                />
                <Button
                  content={!shouldUpdate ? "Add School" : "Update School"}
                  labelPosition="right"
                  icon="checkmark"
                  loading={loading}
                  onClick={!shouldUpdate ? handleAddSchool : handleUpdateSchool}
                  positive={shouldUpdate}
                  primary={!shouldUpdate}
                />
              </Modal.Actions>
            </Modal.Content>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}

export default SchoolForm;
